/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useEffect, useState, useCallback, useContext, useRef,
} from 'react';
import moment from 'moment';
import { motion } from 'framer-motion';
import HeaderContext from '../../../Components/Context/HeaderContext';
import { distributorService } from '../../../service/distributor.service';
import Pagination from '../../../Components/Pagination';
import EmptyScreen from '../../../Components/GlobalEmplyPage';
import OutstandingInvoiceSkeleton from './outstandingInvoiceSkeleton';
import OutstandingFilterModal from './FilterModal';
import { PriceHandler } from '../../../redux/helper/CamelCase';

function OutstandingInvoiceDetailsReport() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [outstandingInvoiceList, setOutstandingInvoiceList] = useState([]);
    const [sortType, setsortType] = useState('GST_INVOICE_DATE+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [loading, setLoading] = useState(true);
    const [outstandingfilterModal, setoutstandingFilterModal] = useState(false);
    const [emptyData, setEmptyData] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [selected, setselected] = useState({
        gst_start_date: '',
        gst_end_date: '',
        ar_start_date: '',
        ar_end_date: '',
    });
    const [Filter, setFilter] = useState({
        customer_code: [],
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage, sortType]);

    const handleOutstandingInvoiceReport = useCallback((() => {
        distributorService.MISOutstandingInvoiceDetails(currentPage, sortType, debouncedSearch, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setOutstandingInvoiceList(response.data.data);
                setCurrentPage(response.data.current_page);
                setTotalPage(response.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }), [currentPage, debouncedSearch, sortType, filterValue]);

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handleExport = useCallback((() => {
        distributorService.MISOutstandingInvoiceDetails(currentPage, sortType, debouncedSearch, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleOutstandingInvoiceReport();
    }, [handleOutstandingInvoiceReport]);

    return (
        <div className="py-6 pr-[18px] main-screen">
            <div className="flex justify-between pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Outstanding Invoice Details Report</h5>
                <div className="flex">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setoutstandingFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px] pr-[15px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[100px] absolute ${exportClick === true ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV
                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf-converter')}

                                >
                                    PDF
                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <OutstandingInvoiceSkeleton /> : (
                <div>
                    {outstandingInvoiceList.length > 0 && (
                        <div
                            className="overflow-auto dropdown-menu  pb-7 relative z-10"
                            style={{ height: 'calc(100vh - 298px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="sticky top-0 left-0 z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[250px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                Customer Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Customer Code
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                GST Invoice No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[250px] text-center flex justify-center items-center pt-4">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                GST Invoice Date
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'GST_INVOICE_DATE+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'GST_INVOICE_DATE+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'GST_INVOICE_DATE+asc') {
                                                                setsortType('GST_INVOICE_DATE+desc');
                                                            } else if (sortType === 'GST_INVOICE_DATE+desc') {
                                                                setsortType('GST_INVOICE_DATE+asc');
                                                            } else {
                                                                setsortType('GST_INVOICE_DATE+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[160px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Unit
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[188px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Class
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                AR Number
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[250px] text-center flex justify-center items-center pt-4">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                AR Date
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'AR_DATE+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'AR_DATE+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'AR_DATE+asc') {
                                                                setsortType('AR_DATE+desc');
                                                            } else if (sortType === 'AR_DATE+desc') {
                                                                setsortType('AR_DATE+asc');
                                                            } else {
                                                                setsortType('AR_DATE+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Description
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[300px] rounded-br-lg rounded-tr-lg">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center ">
                                                Total Outstanding
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'TOTAL_OUTSTANDING_RS+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'TOTAL_OUTSTANDING_RS+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'TOTAL_OUTSTANDING_RS+asc') {
                                                                setsortType('TOTAL_OUTSTANDING_RS+desc');
                                                            } else if (sortType === 'TOTAL_OUTSTANDING_RS+desc') {
                                                                setsortType('TOTAL_OUTSTANDING_RS+asc');
                                                            } else {
                                                                setsortType('TOTAL_OUTSTANDING_RS+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {outstandingInvoiceList.length > 0 && outstandingInvoiceList.map((item) => (
                                        <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                            <td
                                                className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4"
                                                style={{
                                                    background: 'rgba(255, 255, 255, 0.45)',
                                                    backdropFilter: 'blur(5.5px)',
                                                }}
                                            >
                                                {item?.CUSTOMER_NAME}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.CUSTOMER_CODE}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                                {item?.GST_INVOICE_NUMBER === null ? '-' : item?.GST_INVOICE_NUMBER}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.GST_INVOICE_DATE === null ? '-' : moment(item?.GST_INVOICE_DATE).format('DD-MMM-YYYY, HH:mm:ss')}
                                            </td>
                                            <td className="text-sm font-normal py-2.5 px-7 text-center">
                                                {item?.UNIT}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.CLASS}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.AR_NUMBER}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {moment(item?.AR_DATE).format('DD-MMM-YYYY, HH:mm:ss')}
                                            </td>
                                            <td className="text-sm font-normal more-lines text-[#090406] py-1 px-7 text-center">
                                                {item?.DESCRIPTION === null ? '-' : item?.DESCRIPTION}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-left">
                                                {PriceHandler(item?.TOTAL_OUTSTANDING_RS)}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                    )}
                    {outstandingInvoiceList.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            List={outstandingInvoiceList}
                            currentPage={currentPage}
                            totalPage={totalPage}
                        />
                    )}
                    {outstandingfilterModal && (
                        <OutstandingFilterModal
                            outstandingfilterModal={outstandingfilterModal}
                            setoutstandingFilterModal={setoutstandingFilterModal}
                            selected={selected}
                            setselected={setselected}
                            Filter={Filter}
                            setFilter={setFilter}
                            handleFilter={handleFilter}
                            filterValue={filterValue}
                            setfilterValue={setfilterValue}
                            handleOutstandingInvoiceReport={handleOutstandingInvoiceReport}
                            outstandingInvoiceList={outstandingInvoiceList}
                            setOutstandingInvoiceList={setOutstandingInvoiceList}
                            SetSuccessMessage={SetSuccessMessage}
                        />
                    )}
                </div>
            )}
            {emptyData && (
                <EmptyScreen
                    search="yes"
                    text="Outstanding Invoice Report"
                    buttonRequired={false}
                    all={debouncedSearch.length > 0 ? 'under searched term' : 'found'}
                />
            )}

        </div>
    );
}

export default OutstandingInvoiceDetailsReport;
